module.exports = __webpack_public_path__ + "static/Quick Approval Process Icon-hover-6f5b04ae2ab8531933f3d9bbf7be7797.svg";